<template>
  <div class="container center">
    <canvas
      class="hide"
      id="canvas"
    ></canvas>
    <div style="margin: 0px auto; max-width: 320px">
      <video
        v-show="url != false"
        width="100%"
        id="videoMobile"
        controls
        controlslist="nodownload"
      >
        <source :src="url" />
      </video>
    </div>

    <button
      v-if="load"
      class="btn btn-lg btn-success"
    >
      <div
        class="spinner-border text-light"
        role="status"
      >
        <span class="sr-only"></span>
      </div>
    </button>

    <span
      v-if="!load && !next"
      class="btn mt-3 btn-lg btn-success btn-default btn-file"
    >
      COMEÇAR A GRAVAR.
      <input
        type="file"
        ref="file"
        v-on:change="sendMovie()"
        accept="video/*"
        name="answers[video]"
        id="capture"
        capture="camcorder"
      />
    </span>
    <div
      v-if="question.choices.canBeEmpty"
    >
      <button @click="nextQuestion(false)" class="btn mt-3 btn-lg btn-primary" style="width: 90%">
        Pular
      </button>
    </div>
    <button
      @click="saveThumb"
      v-if="!load && next"
      class="btn mt-3 btn-lg btn-primary"
    >
      PRÓXIMA PERGUNTA
      <font-awesome-icon icon="chevron-right" />
    </button>
  </div>
</template>

<script>
export default {
  props: [
    "is_evaluation",
    "question",
    "index",
    "currentTime"
  ],
  data: () => ({
    file: "",
    url: false,
    load: false,
    next: false,
  }),
  watch: {
    question() {
      this.player.dispose();
    }
  },
  methods: {
    nextQuestion() {
      eventBus.$emit("videoRecorded");
      if (this.is_evaluation) {
        this.$emit("nextQuestion", this.file);
        return;
      }
      eventBus.$emit("nextQuestion", this.index);
    },
    sendMovie() {
      this.file = this.$refs.file.files[0];
      this.load = true;
      let formData = new FormData();

      formData.append("answers[video]", this.file);
      formData.append("answers[question_id]", this.question.id);
      formData.append("answers[time_taken]", this.currentTime);

      this.url = URL.createObjectURL(
        document.querySelector("#capture").files[0]
      );

      let video = document.getElementById("videoMobile");
      let canvaElement = document.querySelector("#canvas");
      video.load();
      let question = this.question;

      video.onloadedmetadata = () => {
        setTimeout(() => {
          canvaElement.width = video.videoWidth;
          canvaElement.height = video.videoHeight;

          if (video.duration > question.time) {
            this.load = false;
            this.$toast.error(
              `Tempo de video maior que ${question.time}, por favor grave um vídeo menor`
            );
            return;
          }

          let canvas = this.capture();
          canvas.toBlob((thumb) => {
            formData.append("answers[thumbnail]", thumb);
            formData.append("answers[evaluation_id]", this.question.evaluation_id);
            axios
              .post("/candidates/answers", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((data) => {
                this.$toast.success("Vídeo enviado com sucesso");
                this.nextQuestion();
                this.load = false;
              })
              .catch((error) => {
                this.load = false;
                console.log(error);
              });
          }, "image/png");
        }, 100);
      };

      return;
    },
    capture() {
      let video = document.getElementById("videoMobile");
      var canvas = document.getElementById("canvas");
      // video.addEventListener("loadedmetadata", function() {

      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      return canvas;
      // });
    },
  },
};
</script>
